module.exports = __webpack_public_path__ + "media/images/sport--eishockey-dcf67709eddd64af4f9863650de3ee10.png";